import { render } from "./DropStats.vue?vue&type=template&id=430bba7c&scoped=true"
import script from "./DropStats.vue?vue&type=script&lang=js"
export * from "./DropStats.vue?vue&type=script&lang=js"

import "./DropStats.vue?vue&type=style&index=0&id=430bba7c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-430bba7c"

export default script